<kendo-formfield class="form-field" [formGroup]="formgroup!">
    <kendo-floatinglabel [text]="t7eLabel">
        <kendo-dropdownlist #depts class="ddDept" formControlName="dept" [data]="depts$ | async" textField="depname"
            valueField="depid" [defaultItem]="{ depid: null, depname: 'all'|t7e:'Összes' }" name="depts" [filterable]="true"
            (filterChange)="handleDeptFilter($event)" [loading]="isDeptsLoading">
        </kendo-dropdownlist>
    </kendo-floatinglabel>
</kendo-formfield>